module.exports = __webpack_public_path__ + "img/usMegaMillions_icon.1f6996f9.png";